import React, { Component } from "react";
import { connect } from "react-redux";
import style from "./ReportIncome.module.css";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import SuppliesIncome from "./SuppliesIncome/SuppliesIncome";
import CustomersTreatmentIncome from "./CustomersTreatmentIncome/CustomersTreatmentIncome";
import PracticeIncome from "./PracticeIncome/PracticeIncome";
import api from "../../utils/Api";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";


//The data for tabs working on this page.
const Tabs = [{
  tabId: 1,
  tabName: "Practice Income",
  enable: 1
},
{
  tabId: 2,
  tabName: "Supplies",
  enable: 1
},
{
  tabId: 3,
  tabName: "Customers & Treatments",
  enable: 1
}];

export class ReportIncome extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      activeTab: "",
      isReportGenerated: true,
      payload: {}
    };
  }
 
    componentDidMount(){
      document.title = 'Reports - TechToMedix';
      if(!checkIfPermitted(Permissions.REPORT_PRACTICE_GENERATED_INCOME)){
        this.setState({
          activeTab: "2"
        })
      }else{
        this.setState({
          activeTab: "1"
        })
      }
    }

  /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  updateState = (payload) => {

    this.setState({
      payload: payload
    },()=>{
      console.log("payload", payload)
    })

  }

  
  /**
   * This method will export transaction details to excel file.
   */
  handleExport = async () => {
    this.setState({
      isReportGenerated: false,
    });
    const headers = {
      Accept: "application/xls",
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    let url;
    switch(this.state.activeTab) {
      case "1":
        url = "/report/practiceincome/export?";
        break;
      case "2":
        url = "/report/supplies/export?";
        break;
      case "3":
        url = "/report/customer/export?";
        break;
      default:
        break;
    }


     url += "sort_by=" + this.state.payload.sortBy;

     // Practice income filters
    if (this.state.payload && this.state.payload.practitioner_id) {
      url += "&practitioner_id=" + this.state.payload.practitioner_id;
    }
    if (this.state.payload && this.state.payload.view_by) {
      url += "&view_by=" + this.state.payload.view_by;
    }
    if (this.state.payload && this.state.payload.income_type) {
      url += "&income_type=" + this.state.payload.income_type;
    }


    // Supplies income filters
    if (this.state.payload && this.state.payload.reportsOf) {
      url += "&reports_Of=" + this.state.payload.reportsOf;
    }
    if (this.state.payload && this.state.payload.duration) {
      url += "&duration=" + this.state.payload.duration;
    }
    if (this.state.payload && this.state.payload.based_on) {
      url += "&based_on=" + this.state.payload.based_on;
    }
    if (this.state.payload && this.state.payload.dateFrom) {
      url += "&created_at=gte:" + this.state.payload.dateFrom;
    }
    if (this.state.payload && this.state.payload.dateTo) {
      url += "&created_at=lte:" + this.state.payload.dateTo;
    }


  // Customer income filters
  if (this.state.payload && this.state.payload.age_range) {
    url += "&age_range=" + this.state.payload.age_range;
  }
  if (this.state.payload && this.state.payload.gender) {
    url += "&gender=" + this.state.payload.gender;
  }
  if (this.state.payload && this.state.payload.icd_code) {
    url += "&icd_code=" + this.state.payload.icd_code;
  }
  if (this.state.payload && this.state.payload.medical_aid) {
    url += "&medical_aid:" + this.state.payload.medical_aid;
  }

    try {
      const response = await api.get(url, {
        headers: headers,
        responseType: "blob",
      });
      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        switch(this.state.activeTab){
          case "1": 
           link.setAttribute("download", `PracticeIncome.xlsx`);
           break;
          case "2": 
            link.setAttribute("download", `Supplies.xlsx`);
            break;
          case "3": 
            link.setAttribute("download", `Customer&Treatments.xlsx`);
            break;
          default:
            break;
        }
        document.body.appendChild(link);
        link.click();
        this.setState({
          isReportGenerated: true,
        });
      }
    } catch (error) {
      this.setState({
        isReportGenerated: true,
      });
      console.log("Error for exporting the statements data!", error);
    }
  };


  render() {
    
    const statementsTabData = Tabs.find(
      (element, index) => {
        return element.tabId == this.state.activeTab;
      }
    );


    if(!checkIfPermitted(Permissions.REPORT_PRACTICE_GENERATED_INCOME)){
      Tabs[0].enable = 0
    }
    if(!checkIfPermitted(Permissions.REPORT_CUSTOMER)){
      Tabs[2].enable = 0
    }

    return (
      <div>
        {this.props.loading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="loader" className={style.loading} />
          </div>
        ) : (
            <div className={`inventory-audit ${style.inventoryAuditMainWrapper}`}>
              <div className="row">
                <div className="col-md-6">
                  <h3>Reports - Income</h3>
                </div>
                <div
                className={`col-md-6 order-3 order-md-2 d-flex justify-content-start justify-content-md-end ${style.addRoleBtnWrapper}`}
              >
                {!this.state.isReportGenerated && (
                  <img
                    src={ttmLoader}
                    alt="loader"
                    className={style.exportLoaderImage}
                  />
                )}
                <Button
                  color="primary"
                  onClick={this.handleExport}
                  className={style.addBtn}
                >
                  Export
                </Button>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-12">
                  <p>
                  The statements are differentiated for patients and suppliers. 
                  Both the tabs has separate filters. The statements shows the data related to transactions. 
                  The view action opens a popup showing the payment details. 
                  The export button downloads the data in excel format.
                  </p>
                </div>
              </div> */}
              <div className={`row ${style.reportsTabWrapper}`}>
                <div className="col-md-12">
                  <Nav tabs>
                    {Tabs && 
                    Tabs.map(
                      (element, index) => {
                        if(element.enable === 1){
                         return (<NavItem key={`${index + 1}`}>
                            <NavLink
                              className={{
                                active: this.state.activeTab === `${index + 1}`,
                              }}
                              onClick={() => {
                                this.toggle(`${index + 1}`);
                              }}
                            >
                              {element.tabName}
                            </NavLink>
                        </NavItem>)
                      }
                    }
                    )}
                  </Nav>
                  <TabContent
                    activeTab={this.state.activeTab}
                    className={style.tabContentWrapper}
                  >
                  {Tabs[0].enable === 1 &&
                    (<TabPane
                    tabId={`1`}
                    key={`1`}
                          className={style.auditTrailTabContent}
                        >
                        {this.state.activeTab == 1 &&(
                        <PracticeIncome
                         updateParentState={this.updateState} />
                        )} 
                      </TabPane>)}
                      <TabPane
                        tabId={`2`}
                        key={`2`}
                        className={style.auditTrailTabContent}
                      >
                        {this.state.activeTab == 2 &&(
                        <SuppliesIncome
                        updateParentState={this.updateState} />
                        )}
                      </TabPane>
                      {Tabs[2].enable === 1 &&
                      (<TabPane
                        tabId={`3`}
                        key={`3`}
                        className={style.auditTrailTabContent}
                      >
                        {this.state.activeTab == 3 &&(
                        <CustomersTreatmentIncome
                         updateParentState={this.updateState} />  
                        )}
                      </TabPane>
                      )}
                  </TabContent>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}


export default ReportIncome;
